import React from "react";
import { motion } from "framer-motion";
import "../Styles/Vision.css";
import { FaCheckCircle } from "react-icons/fa";

import integrityImg from "../../Asserts/circle1.png";
import customerImg from "../../Asserts/circle2.png";
import collaborationImg from "../../Asserts/circle3.png";
import valueImg from "../../Asserts/circle4.png";

import JasmineLogo from "../../Asserts/Jasmine-Logo 1.png";
import GenauLogo from "../../Asserts/Genau-Logo 1.png";

const Vision = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        ease: "easeOut",
      },
      
    }),
     };

    const companyData = [
    {
      logo: JasmineLogo,
      name: "Jasmine",
      description:
        "Joint Venture with global major DSM-Firmenich, Jasmine manufactures natural floral extracts, spice extracts and essential oils.",
    },
    {
      logo: GenauLogo,
      name: "Genau Extrusions",
      description:
        "Genau Extrusions delivers high-quality engineered extrusions with precision manufacturing for industrial applications.",
    },
  ];
 

  return (
    <div className="vision-container">

      <h2 className="vision-title">
        Our <span className="highlight-orange">Vision</span>{" "}
        <span className="and">and</span>{" "}
        <span className="highlight-orange">Core Values</span>
      </h2>

      <p className="vision-sub">
        <strong>Vision:</strong> Help users achieve highest electrical energy productivity. <br /><br />
        <strong>Our core values:</strong> Integrity | Customer centricity | Collaboration | Value creation
      </p>


      {/* ===== MAIN GRID ===== */}
      <div className="vision-grid">

        {/* Top Left - Integrity */}
        <motion.div
          className="vision-card tl"
          style={{ backgroundImage: `url(${integrityImg})` }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          custom={0}
        >
          <div className="overlay">
            <h3>Integrity</h3>
            <p>
      
              We uphold the utmost standards of personal integrity and unwavering moral principles
 
            </p>
          </div>
        </motion.div>

        {/* Top Right - Customer */}
        <motion.div
          className="vision-card tr"
          style={{ backgroundImage: `url(${customerImg})` }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          custom={1}
        >
          <div className="overlay">
            <h3>Customer Centricity</h3>
            <p>
             At every touchpoint, we strive to create a positive customer experience—one that lingers in their memory and beckons them back.
            </p>
          </div>
        </motion.div>

        {/* Center Circle */}
        <div className="center-circle">
         
          <ul>
            <li><FaCheckCircle className="list-check-icon" /> Industry veterans</li>
            <li><FaCheckCircle className="list-check-icon" /> Diverse application know–how</li>
            <li><FaCheckCircle className="list-check-icon" /> Problem solving assistance</li>
            <li><FaCheckCircle className="list-check-icon" /> Best in industry cost-to-value</li>
            <li><FaCheckCircle className="list-check-icon" /> Life-cycle engagement</li>
          </ul>
        </div>

        {/* Bottom Left - Collaboration */}
        <motion.div
          className="vision-card bl"
          style={{ backgroundImage: `url(${collaborationImg})` }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          custom={2}
        >
          <div className="overlay">
            <h3>Collaboration</h3>
            <p>
              We foster a shared vision and a spirit of teamwork.  Central to our approach is close collaboration with both customers and suppliers.
            </p>
          </div>
        </motion.div>

        {/* Bottom Right - Value Creation */}
        <motion.div
          className="vision-card br"
          style={{ backgroundImage: `url(${valueImg})` }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          custom={3}
        >
          <div className="overlay">
            <h3>Value Creation</h3>
            <p>
              We nurture an environment where everyone thrives through learning, innovation, and growth.
            </p>
          </div>
        </motion.div>

      </div>

      

       <div className="group-companies-container">
      <h2 className="section-title"><span className="highlight-orange">Group</span> Companies</h2>

      <div className="companies-row">
        {companyData.map((company, index) => (
          <div key={index} className="company-card">
            <div className="logo-area">
              <img
                src={company.logo}
                alt={`${company.name} logo`}
                className="company-logo"
              />
            </div>
            <p className="company-description">{company.description}</p>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Vision;
